import React, { useEffect } from "react";
import AboutBanner from "../components/aboutpage/AboutBanner";
import OurStory from "../components/aboutpage/OurStory";
import Collection from "../components/aboutpage/Collection";
import QuoteSection from "../components/aboutpage/QuoteSection";

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="">
      <AboutBanner />
      <OurStory />
      <Collection />
      <QuoteSection />
    </div>
  );
}
